import { ReferringProvider, IReferringProviderRepo } from "../entities/referringProvider"
import { getTenantId } from "../../common/jwt"
import axios from "../../common/axios"

export class ReferringProviderRepo implements IReferringProviderRepo {
    async listReferringProviders(tenantId: number, search: string): Promise<ReferringProvider[]> {
        const resp = await axios.get(`/v2/referring-providers`, { params: { search } })
        return resp.data
    }
}